import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Loading, Modal } from 'carbon-components-react';
import { Card } from '../../../components';
import { esqueciSenhaService } from '../../../services/Api';

class EsqueciSenha extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // isLoading: false,
      email: '',
      // error: null,
      successModel: false,
    };
  }

  onChangeText = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  toggleSuccessModal = () => {
    this.setState(prevState => ({
      successModel: !prevState.successModel,
    }));
  };

  onsubmit = e => {
    const { email } = this.state;
    e.preventDefault();
    if (e.target.checkValidity()) {
      this.esqueciSenha(email);
    }
  };

  esqueciSenha = async user => {
    this.setState({ isSaving: true });
    esqueciSenhaService(user)
      .then(() => {
        this.setState({ isSaving: false });
        this.toggleSuccessModal();
      })
      .catch(err => {
        this.setState({ isSaving: false });
        console.log(err);
          if (err.code === 400 && err.message) toast.error(err.message);
          else toast.error(err.message);
      });
  };

  render() {
    const { email, isSaving, successModel } = this.state;

    return (
      <div className="login-block">
        <Card>
          <h2 className="logo">DMJob</h2>
          <form onSubmit={this.onsubmit}>
            <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
              <label className="bx--label">E-mail</label>
              <input
                type="email"
                className="bx--text-input"
                required
                placeholder="E-mail"
                name="email"
                value={email}
                onChange={this.onChangeText}
              />
            </div>

            <div className="bx--col-md-12">
              <button
                type="submit"
                className="bx--btn btn-login-step btn-secondary-color v-md-margin"
                disabled={!email}
              >
                Enviar
              </button>
              <NavLink to="/login" className="underline">
                Voltar para o login
              </NavLink>
            </div>
          </form>
        </Card>
        <Modal
          className="bx--modal-secondary-hide"
          open={successModel}
          onRequestSubmit={this.toggleSuccessModal}
          onRequestClose={this.toggleSuccessModal}
          modalHeading="Sem problemas!"
          primaryButtonText="Ok, entendi"
          secondaryButtonText={null}
        >
          <div className="warning-modal-txt">
            <h3> Uma nova senha foi enviada para o seu e-mail. </h3>
            <p className="font-size-13 v-md-margin">
              Não esqueça de redifinir a sua senha em seu perfil.
            </p>
          </div>
        </Modal>
        {isSaving && <Loading small />}
      </div>
    );
  }
}

export default EsqueciSenha;



// WEBPACK FOOTER //
// ./src/screens/admin/Users/EsqueciSenha.js